FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="checkbox"]';
    var eventsAreSet = false;

    //  box
    var box = {
        in: 'fa-check-square-o',
        out: 'fa-square-o'
    };

    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 95,
        value: false,
        noedit: false,
        locked: false
    };

    //  props
    var props = {
        reset: function (value) {
            var e = $(this.element);
            e.data().value = value;
            resetCheckBox(e);
        }
    };


    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set event
        $(document).off('click keypress', ELEM)
            .on('click.' + NAMESPACE, ELEM, clickCheckBox)
            .on('keypress.' + NAMESPACE, ELEM, handleKeypress);
    }


    //  get status
    function getCheckBox(wireEvent, container) {
        var list = [];

        //  set list
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        //  bail
        if (list.length === 0) {
            return;
        }

        //  wire events
        if (wireEvent && !eventsAreSet) {
            setEvents();
            eventsAreSet = true;
        }

        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data(), props);

            //  custom options
            if (typeof options.value === 'string') {
                options.value = options.value.getBool();
            }

            //  set elem data
            me.setControlItemOptions(elem, options);

            //  reset
            elem.html('').append("<i class='fa fa-fw'></i>");
            resetCheckBox(elem);

            // Add hidden input
            elem.prepend("<input type='hidden' value='" + options.value + "' name='" + elem.attr('name') + "' />");
            elem.attr('name', '');


            //  set cursor
            if (!options.noedit) {
                elem.css({ cursor: 'pointer' });
                elem.attr('tabindex', 0);
            }
        });
    }


    // reset checkbox
    function resetCheckBox(e) {
        if (!e.data('value')) {
            e.children('i').removeClass(box.in).addClass(box.out);
        } else {
            e.children('i').removeClass(box.out).addClass(box.in);
        }
    }


    //  click checkbox
    function clickCheckBox() {
        var e = $(this);
        var data = e.data();
        if (data.noedit) {
            return;
        }

        if (!data.locked) {
            data.element = e;
            data.value = data.value ? false : true;
            e.data(data);
            e.attr('data-value', data.value);
            resetCheckBox(e);
            $("input", e).val(data.value).change();
        }

        me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });
    }

    function handleKeypress(e) {
        if (e.keyCode == 32 || e.charCode == 32) {
            clickCheckBox.call(this);
        }
    }




    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setCheckBox = function (wireEvent, container) {
        getCheckBox(wireEvent, container);

        // create update checkbox function
        if (!jQuery.isFunction($.fn.updateCheckbox)) {
            (function ($) {
                $.fn.updateCheckbox = function (options) {
                    if (options === undefined) {
                        options = {
                            value: null,
                            enable: null
                        };
                    }
                    this.each(function () {
                        if (!$(this).data('fd').toLowerCase() === "checkbox") {
                            return this;
                        }
                        if (options.value !== undefined && options.value !== null) {
                            $(this).data('value', options.value).attr('data-value', options.value);
                        }
                        if (options.enable !== undefined && options.enable !== null) {
                            $(this).data('noedit', !options.enable).attr('data-noedit', !options.enable).css('cursor', options.enable ? 'pointer' : 'default').attr('tabindex', options.enable ? 0 : "");
                        }

                        resetCheckBox($(this));
                    });
                    return this;
                };
            }(jQuery));
        }
    };

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));